module.exports = __webpack_public_path__ + "static/img/8.3f762e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/8.png
// module id = dhEb
// module chunks = 0